<div class="modal-backdrop">
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header " style="display: flex; justify-content: space-between; align-items: center;">
        <h3 class="modal-title">Detalhes Completos do Plano: {{ data.plan.name }}</h3>
        <button mat-icon-button (click)="onClose()" class="close-button">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body">
        <div class="plan-full-details">
          <!-- Informações do Plano -->
          <div class="info-section">
            <div class="title-section">Informações Gerais</div>
            
            <div class="info-grid">
              <div class="info-row">
                <span class="info-label">ID:</span>
                <span class="info-data">{{ data.plan.id }}</span>
              </div>
              
              <div class="info-row">
                <span class="info-label">CPF/CNPJ:</span>
                <span class="info-data">{{ formatCpfCnpj(data.plan.cpfcnpj) }}</span>
              </div>
              
              <div class="info-row">
                <span class="info-label">Status:</span>
                <span class="badge" [ngClass]="data.plan.active ? 'badge-success' : 'badge-error'">
                  {{ data.plan.active ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
              
              <div class="info-row">
                <span class="info-label">Criado em:</span>
                <span class="info-data">{{ formatDate(data.plan.createdAt) }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Última Atualização:</span>
                <span class="info-data">{{ formatDate(data.plan.updatedAt) }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Último Pagamento:</span>
                <span class="info-data">{{ data.plan.lastPaymentDate ? formatDate(data.plan.lastPaymentDate) : '—' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Próximo Pagamento:</span>
                <span class="info-data">{{ data.plan.nextPaymentDate ? formatDate(data.plan.nextPaymentDate) : '—' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Total Bruto:</span>
                <span class="info-data">{{ formatPrice(data.plan.grossTotal) }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Total de Descontos:</span>
                <span class="info-data">{{ formatPrice(data.plan.totalDiscounts) }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Total Final:</span>
                <span class="info-data highlight">{{ formatPrice(data.plan.finalTotal) }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Expira em:</span>
                <span class="info-data">{{ data.plan.expiresAt ? formatDate(data.plan.expiresAt) : '—' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Pagador Efetivo:</span>
                <span class="info-data">{{ data.plan.payerCnpj ? formatCpfCnpj(data.plan.payerCnpj) : '—' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Pagador Aceitou:</span>
                <span class="info-data">{{ data.plan.payerAccepted === true ? 'Sim' : (data.plan.payerAccepted === false ? 'Não' : '—') }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Tipo de Pacote:</span>
                <span class="info-data">{{ data.plan.packageType || '—' }}</span>
              </div>

              <div class="info-row">
                <span class="info-label">Pronto para ativação:</span>
                <span class="info-data">{{ data.plan.readyForActivation ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>

          <!-- Ações de Pagamento -->
          <div class="payment-actions">
            <button mat-stroked-button color="primary" *ngIf="data.plan.payments?.length > 0" (click)="viewPayments()">
              <mat-icon>receipt_long</mat-icon>
              Ver Pagamentos ({{ data.plan.payments?.length }})
            </button>

            <button mat-raised-button color="accent" *ngIf="!data.plan.payments || data.plan.payments.length === 0" (click)="generatePayment()">
              <mat-icon>payment</mat-icon>
              Gerar Pagamento
            </button>

            <button mat-button (click)="navigateToInvoices()">
              <mat-icon>open_in_new</mat-icon>
              Ver Faturas
            </button>
          </div>

          <!-- Total do Plano -->
          <div class="card card-dark total-section">
            <div class="total-content">
              <div>
                <strong>Valor Total do Plano</strong>
                <p>Inclui todos os itens e descontos aplicados</p>
              </div>
              <div class="total-value">
                {{ formatPrice(data.planTotal) }}
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- ITENS DO PLANO -->
          <div class="items-section">
            <div class="title-section">Itens do Plano ({{ getItemsCount() }})</div>

            <div *ngIf="data.plan.items && data.plan.items.length > 0; else noItems">
              <table mat-table [dataSource]="data.plan.items" class="items-table">
                <ng-container matColumnDef="product">
                  <th mat-header-cell *matHeaderCellDef>Produto</th>
                  <td mat-cell *matCellDef="let item">{{ item.product?.name }}</td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                  <td mat-cell *matCellDef="let item">{{ item.quantity }}</td>
                </ng-container>

                <ng-container matColumnDef="unitPrice">
                  <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
                  <td mat-cell *matCellDef="let item">{{ formatPrice(item.unitPrice) }}</td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Ações</th>
                  <td mat-cell *matCellDef="let item">
                    <button mat-icon-button color="warn" (click)="removeItem(item.id!)" matTooltip="Remover item">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['product','quantity','unitPrice','actions']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['product','quantity','unitPrice','actions'];"></tr>
              </table>
            </div>

            <ng-template #noItems>
              <p class="empty-message">Nenhum item adicionado</p>
            </ng-template>

            <!-- Formulário para adicionar item -->
            <h4>Adicionar Item</h4>
            <form [formGroup]="itemForm" class="item-form">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Produto</mat-label>
                <mat-select formControlName="productId">
                  <mat-option *ngFor="let product of data.products" [value]="product.id">{{ product.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Quantidade</mat-label>
                <input matInput type="number" formControlName="quantity" min="1">
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Preço Unitário</mat-label>
                <input matInput formControlName="unitPrice" appCurrencyMask autocomplete="off">
              </mat-form-field>

              <button mat-raised-button color="primary" (click)="addItem()" [disabled]="itemForm.invalid">
                <mat-icon>add</mat-icon>
                Adicionar
              </button>
            </form>
          </div>

          <mat-divider></mat-divider>

          <!-- DESCONTOS DO PLANO -->
          <div class="discounts-section">
            <div class="title-section">Descontos ({{ getDiscountsCount() }})</div>

            <div *ngIf="data.plan.discounts && data.plan.discounts.length > 0; else noDiscounts">
              <div class="discounts-list">
                <div class="card discount-card" *ngFor="let discount of data.plan.discounts">
                  <div class="discount-header">
                    <div>
                      <strong>{{ discount.description }}</strong>
                      <span class="badge" [ngClass]="discount.active ? 'badge-primary' : 'badge-error'">
                        {{ discount.active ? 'Ativo' : 'Inativo' }}
                      </span>
                    </div>
                    <button mat-icon-button color="warn" (click)="removeDiscount(discount.id!)" matTooltip="Remover desconto">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                  <div class="discount-details">
                    <div class="detail-item">
                      <small>Tipo:</small>
                      <p>{{ getDiscountTypeLabel(discount.type) }}</p>
                    </div>

                    <div *ngIf="discount.type === 'PERCENTAGE' && getDiscountPercentage(discount) !== null" class="detail-item">
                      <small>Porcentagem:</small>
                      <p class="highlight">{{ (getDiscountPercentage(discount)! * 100).toFixed(2) }}%</p>
                    </div>

                    <div *ngIf="discount.type === 'FIXED' && getDiscountAmount(discount) !== null" class="detail-item">
                      <small>Valor do Desconto:</small>
                      <p class="highlight">{{ formatPrice(getDiscountAmount(discount)!) }}</p>
                    </div>

                    <div class="detail-item">
                      <small>ID:</small>
                      <p>{{ discount.id }}</p>
                    </div>

                    <div class="detail-item">
                      <small>Criado em:</small>
                      <p>{{ formatDate(discount.createdAt) }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noDiscounts>
              <p class="empty-message">Nenhum desconto adicionado</p>
            </ng-template>

            <!-- Formulário para adicionar desconto -->
            <h4>Adicionar Novo Desconto</h4>
            <form [formGroup]="discountForm" class="discount-form">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Tipo de Desconto</mat-label>
                <mat-select formControlName="type">
                  <mat-option value="PERCENTAGE">Porcentagem</mat-option>
                  <mat-option value="FIXED_AMOUNT">Valor Fixo</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="description">
              </mat-form-field>

              <mat-form-field *ngIf="discountForm.value.type === 'PERCENTAGE'" appearance="outline" floatLabel="always">
                <mat-label>Porcentagem (%)</mat-label>
                <input matInput formControlName="percentage" appPercentageMask autocomplete="off">
              </mat-form-field>

              <mat-form-field *ngIf="discountForm.value.type === 'FIXED_AMOUNT'" appearance="outline" floatLabel="always">
                <mat-label>Valor do Desconto</mat-label>
                <input matInput formControlName="amount" appCurrencyMask autocomplete="off">
              </mat-form-field>

              <div class="form-actions">
                <button mat-raised-button color="primary" (click)="addDiscount()" [disabled]="discountForm.invalid">
                  <mat-icon>add</mat-icon>
                  Adicionar Desconto
                </button>
              </div>
            </form>
          </div>

          <mat-divider></mat-divider>

          <!-- Aplicar Pacote -->
          <div class="package-section">
            <h4>Aplicar pacote de produtos ao plano</h4>
            <form [formGroup]="applyPackageForm" class="apply-package-form">
              <mat-form-field appearance="outline">
                <mat-label>Pacote de produtos</mat-label>
                <mat-select formControlName="productPackageId">
                  <mat-option *ngFor="let pkg of data.productPackages" [value]="pkg.id">{{ pkg.name }}</mat-option>
                </mat-select>
              </mat-form-field>

              <button mat-flat-button color="primary" (click)="applyPackage()" [disabled]="applyPackageForm.invalid">
                Aplicar pacote e gerar fatura
              </button>
            </form>
          </div>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="modal-footer">
        <button mat-stroked-button (click)="onClose()" class="btn btn-ghost">
          <mat-icon>close</mat-icon>
          Fechar
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
